<div class="app-content-container">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- /Logo Box -->
    <div class="flex flex-col h-1/5 w-4/5 place-content-center">
      <a class="h-full w-full flex flex-col justify-center items-center" target="_blank" [href]="config.logoLink" rel="noopener">
        <img class="h-[2rem]" [src]="logoUrl" alt="LOGO" />
      </a>
    </div>

    <div class="flex flex-col h-3/5 w-4/5 max-w-screen-sm place-content-center">
      <div class="flex flex-col justify-center h-full mb-2 signup-success">
        <h2 class="text-center mt-8 text-xl font-bold" i18n>Thanks for signing up!</h2>

        <p class="text-center mt-12 text-xs font-bold email-address" i18n>We sent a confirmation link to:</p>

        <p class="text-center mt-2 text-sm font-bold">{{ userEmailAddress }}</p>

        <!-- Back to login page -->
        <div class="flex flex-col justify-center mt-6">
          <a class="text-center font-bold underline text-sm link-color" [routerLink]="['/login']" i18n>Back to login</a>
        </div>
      </div>
    </div>

    <div class="flex flex-col h-1/5 w-4/5 place-content-center">
      <div class="flex flex-col justify-end h-full mb-2"></div>
    </div>
  </div>
</div>
<div class="app-footer-container">
  <div class="flex flex-col justify-end h-full mb-2">
    <sp-footer></sp-footer>
  </div>
</div>
